import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["innerHTML"]

import { ref } from 'vue'
import type { RewardCardType, RewardPurchasePayload } from '@/types'
import ModalContainer from '@/components_new/ModalItems/ModalContainer.vue'
import Button from '@/components_new/Button.vue'
import { formatValue } from '@/utils/numbers'
import { RequestStatus } from '@/utils/requests/types'
import Typography from '@/components_new/Typography.vue'
import TextInput from '@/components_new/TextInput/TextInput.vue'
import RewardCard from './RewardCard.vue'
import SuccessPurchaseImage from './images/success_purchase.webp'


export default /*@__PURE__*/_defineComponent({
  __name: 'RewardPurchaseModal',
  props: {
    purchase: {},
    doPurchase: { type: Function }
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const purchaseState = ref<RequestStatus>('none')

const doTransaction = async () => {
    if (!props.purchase) {
        return
    }
    purchaseState.value = 'pending'
    try {
        await props.doPurchase({
            rewardId: props.purchase.card.id,
            userEmail: props.purchase.email,
            countryCode: props.purchase.country.code,
        })
        purchaseState.value = 'ok'
    } catch {
        purchaseState.value = 'error'
        setTimeout(() => {
            purchaseState.value = 'none'
        }, 1000)
    }
}

const closeModal = () => {
    purchaseState.value = 'none'
    emit('closeModal')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalContainer, {
    isOpened: !!props.purchase,
    class: _normalizeClass(_ctx.$style.dialog),
    onCloseModal: closeModal
  }, _createSlots({ _: 2 }, [
    (props.purchase)
      ? {
          name: "custom-content",
          fn: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.content)
            }, [
              (purchaseState.value === 'ok')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.cardOrImage),
                    src: _unref(SuccessPurchaseImage)
                  }, null, 10, _hoisted_1))
                : (_openBlock(), _createBlock(RewardCard, {
                    key: 1,
                    class: _normalizeClass(_ctx.$style.cardOrImage),
                    type: props.purchase.card.type,
                    value: props.purchase.card.value,
                    currency: props.purchase.card.currency
                  }, null, 8, ["class", "type", "value", "currency"])),
              _createVNode(Typography, {
                type: "header",
                size: "s",
                class: _normalizeClass(_ctx.$style.title)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(purchaseState.value === 'ok'
                            ? _ctx.$tr('rewards.purchase_dialog_success')
                            : _ctx.$tr('rewards.purchase_dialog_title')), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(TextInput, {
                id: "reward-purchase",
                name: "reward-purchase",
                readonly: "",
                class: _normalizeClass(_ctx.$style.email),
                labelText: _ctx.$tr('rewards.purchase_dialog_email'),
                value: props.purchase.email
              }, null, 8, ["class", "labelText", "value"]),
              _createVNode(Typography, {
                size: "s",
                class: _normalizeClass(_ctx.$style.description)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$tr('rewards.purchase_dialog_description', { country: props.purchase.country.nameEn })
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              }, 8, ["class"])
            ], 2)
          ]),
          key: "0"
        }
      : undefined,
    (props.purchase)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            (purchaseState.value === 'none')
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  width: "full",
                  size: "l",
                  interfaceTarget: "purchase",
                  iconLeft: "silver_fennec_coin_small",
                  onClick: doTransaction
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(formatValue)(props.purchase.card.price)), 1)
                  ]),
                  _: 1
                }))
              : (purchaseState.value === 'pending')
                ? (_openBlock(), _createBlock(Button, {
                    key: 1,
                    width: "full",
                    interfaceTarget: "loader",
                    color: "carbon-300",
                    size: "l",
                    icon: "loader",
                    disabled: ""
                  }))
                : (purchaseState.value === 'error')
                  ? (_openBlock(), _createBlock(Button, {
                      key: 2,
                      width: "full",
                      color: "rose-400",
                      interfaceTarget: "do-transaction",
                      size: "l",
                      onClick: doTransaction
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tr('rewards.purchase_dialog_error')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(Button, {
                      key: 3,
                      width: "full",
                      interfaceTarget: "success-close",
                      size: "l",
                      onClick: closeModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tr('rewards.purchase_dialog_success_button')), 1)
                      ]),
                      _: 1
                    })),
            _createVNode(Button, {
              width: "full",
              color: "carbon-400",
              size: "l",
              interfaceTarget: "close",
              class: _normalizeClass(_ctx.$style.non_desktop),
              onClick: closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tr('rewards.purchase_dialog_close')), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["isOpened", "class"]))
}
}

})